import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: "Does it replace my federation's program or levels?",
  a: "No. It works alongside any level system. The lanes use generic labels — Beginner, Developing and Advanced — and Bonus 01, the Lane-to-Level Map, helps you match them to the levels your club already uses. It is not affiliated with any federation or skating program."
}, {
  q: 'Who wrote this? Does it really know figure skating?',
  a: "It is written in the language of the sport — edges, crossovers, three-turns, mohawks, spirals, spins — with step-by-step progressions and the most common error for every skill. It is written for qualified coaches: each skater's readiness and the specific technique stay with you."
}, {
  q: "It's a PDF. How will I know how to set up the ice?",
  a: 'Every lesson comes with a top-down rink diagram: the three lanes, cones, direction arrows and standard edge notation (RFO, LFI, RBO, LBI), plus distances, reps and when to rotate on the whistle.'
}, {
  q: 'I already have lesson plans from my federation. Why would I need this?',
  a: 'Basic plans tell you what to teach at each level. This shows you how to run every level at once, every week: a warm-up game, a three-lane circuit and a group phrase that builds into your season show. One payment, no subscription.'
}, {
  q: 'I like to choreograph myself. Is the show number fixed?',
  a: 'Use it as-is or as a starting point. Volume 5 gives you the 8-Count Builder and the Formation Grid to write your own phrases and formations — the finished number is there for the weeks you need it.'
}, {
  q: 'Do I have to start at Week 1?',
  a: 'No. Each volume covers one family of skills and works on its own, so buying mid-season you can start with the volume that matches what your group is working on right now.'
}, {
  q: 'Is it for ice or roller skating?',
  a: 'Figure skating on ice. The drills are not adapted for roller skates.'
}, {
  q: 'What about music?',
  a: 'Volume 5 shows you how to choose and cut show music by structure and BPM — no song titles or lyrics. Use music you are licensed to play at your rink.'
}, {
  q: 'Is it printable or digital only?',
  a: 'Landscape PDFs that read well on a phone or tablet at the boards, and print cleanly to laminate.'
}, {
  q: 'How do I get it?',
  a: 'Instant download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-ice text-ink" data-id="element-109" data-mp="23fy4yy3sqn40">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-110" data-mp="1zew64idskd2k">
        <div className="text-center" data-id="element-111" data-mp="s2dtpauonre1">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-amber-deep" data-id="element-112" data-mp="s3fbrza49e59">
            Before you buy
          </p>
          <h2 id="faq-heading" className="mt-3 font-display font-bold text-rink text-3xl sm:text-5xl" data-id="element-113" data-mp="o2ve8ulms8il">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-114" data-mp="33nd0nij08iv0">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-card border border-ice-dark bg-white" data-id="element-115" data-mp="3dfsi8eqe35fd" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-semibold text-rink focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-deep" data-id="element-116" data-mp="3igq3j06p4fl3">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-amber-deep" aria-hidden="true" data-id="element-117" data-mp="21zu7m6fkcbc1" /> : <PlusIcon className="h-5 w-5 flex-none text-amber-deep" aria-hidden="true" data-id="element-118" data-mp="11rckc3yhusxq" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-119" data-mp="1bqlccr9stxhg">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}